import { render, staticRenderFns } from "./SubOptionForm.vue?vue&type=template&id=2141aeca&scoped=true&"
import script from "./SubOptionForm.vue?vue&type=script&lang=js&"
export * from "./SubOptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2141aeca",
  null
  
)

export default component.exports